import { render } from "./ViewLoadDetails.vue?vue&type=template&id=ce965d8e&scoped=true"
import script from "./ViewLoadDetails.vue?vue&type=script&lang=js"
export * from "./ViewLoadDetails.vue?vue&type=script&lang=js"

import "./ViewLoadDetails.vue?vue&type=style&index=0&id=ce965d8e&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce965d8e"]])

export default __exports__